import { createContext, useContext } from 'react';

// True for an Event Viewer (view-only Event Management): pages show their
// data but hide anything that would change it. The backend refuses every
// change from a viewer regardless (see ensureEventView in backend/index.js)
// — this just keeps buttons that would fail out of the way.
export const EventReadOnlyContext = createContext(false);
export const useEventReadOnly = () => useContext(EventReadOnlyContext);
